<template>
    <div class="content-box">
         <div class="content">
             <div class="title-box">
                 <div class="title">
                     <div class="title-text">车队管理高效化</div>
                     <div class="title-e">MANAGEMENT EFFICIENCY</div>
                     <div class="title-line"></div>
                 </div>
                 <div class="end-rukou">
                 </div>
             </div>
             <div class="describe">
                 新能源城市配送共享服务平台，可帮助运力企业高效化的管理车队。通过自建的智慧物流大数据平台和人工智能技术，帮助企业安全管理车辆，通过车辆调度来优化行程，实现车队成本控制。
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon421"></span> 车队成本控制
                 </div>
                 <div class="row-item">
                     <span class="icon-img icon422"></span> 车辆调度
                 </div>
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon423"></span> 车辆安全管理
                 </div>
                 <div class="row-item">
                     <span class="icon-img icon424"></span> 行程优化
                 </div>
             </div>

             <div class="data-describe">
                 <div class="data-box data-one">
                     <div class="data-num">30<span class="min-span">%</span></div>
                     <div class="data-synopsis">
                         <p>空返率降低30%</p>
                     </div>
                 </div>
                 <div class="data-line"></div>
                 <div class="data-box data-t">
                     <div class="data-num">50<span class="min-span">%</span></div>
                     <div class="data-synopsis">
                         <p>调度成本降低50%</p>
                     </div>
                 </div>
             </div>

             <div class="img-describe img42"></div>
         </div>
    </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
}
</script>
<style src="./../../../styles/public-item.less" lang="less" scoped></style>
